import { useEffect, useState } from 'react'

const MOBILE_MAX_WIDTH = 767.98

const getIsMobile = () => {
  if (typeof window === 'undefined') return false
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches
  }
  if (typeof window.innerWidth === 'number') {
    return window.innerWidth <= MOBILE_MAX_WIDTH
  }
  return false
}

export default function useIsMobileScreen() {
  const [isMobile, setIsMobile] = useState(getIsMobile)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    if (typeof window.matchMedia !== 'function') {
      const onResize = () => setIsMobile(getIsMobile())
      window.addEventListener('resize', onResize)
      return () => window.removeEventListener('resize', onResize)
    }

    const mql = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`)
    const listener = (e) => setIsMobile(e.matches)

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', listener)
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(listener)
    }

    setIsMobile(mql.matches)

    return () => {
      if (typeof mql.removeEventListener === 'function') {
        mql.removeEventListener('change', listener)
      } else if (typeof mql.removeListener === 'function') {
        mql.removeListener(listener)
      }
    }
  }, [])

  return isMobile
}
